"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const button_1 = __importDefault(require("@kyruus/button"));
const messages_1 = require("../../lib/messages");
const constants_1 = require("../../lib/constants");
const styles_1 = require("./styles");
function NoResults({ term, state, send, showClearSearchButton }) {
    if (!state.matches(constants_1.states.noResults)) {
        return null;
    }
    return (react_1.default.createElement(styles_1.NoResultsContainer, { "data-testid": "NoResults" },
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, Object.assign(Object.assign({}, messages_1.messages.infoListBoxNoResults), { values: {
                term
            } }))),
        showClearSearchButton && (react_1.default.createElement(button_1.default, { "data-testid": "NoResultsClear", mode: "flat", onClick: (e) => {
                e.preventDefault();
                send({
                    type: constants_1.events.CLEAR_TERM
                });
            } },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.messages.infoListBoxClearSearch))))));
}
exports.default = NoResults;
//# sourceMappingURL=NoResults.js.map